import { IGeneralConfigItem } from '../common/interfaces/config.interface'
import { apiUrl } from '../config/api'

export type ConfigDocumentKey = 'contrato_administracion' | 'reglamento_fondos_mutuos'

export interface IConfigDocument {
  key: ConfigDocumentKey
  draft: string | null
  published: string | null
}

export const ConfigurationService = () => {
  const configurationList = async () => (await apiUrl.get('/configuration/list')).data

  const updateConfiguration = async (data: IGeneralConfigItem) => {
    const { id, title, description, status } = data
    return (await apiUrl.patch(`/configuration/update/${id}`, { id, title, description, status }))
      .data
  }

  const uploadConfigDocument = async (key: ConfigDocumentKey, file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return (await apiUrl.put(`/configuration/documents/${key}`, formData)).data
  }

  const publishConfigDocument = async (key: ConfigDocumentKey) =>
    (await apiUrl.post(`/configuration/documents/${key}/publish`)).data

  const downloadConfigDocumentDraft = async (key: ConfigDocumentKey): Promise<Blob> =>
    (await apiUrl.get(`/configuration/documents/${key}/draft/download`, { responseType: 'blob' }))
      .data

  const downloadConfigDocumentPublished = async (key: ConfigDocumentKey): Promise<Blob> =>
    (
      await apiUrl.get(`/configuration/documents/${key}/published/download`, {
        responseType: 'blob',
      })
    ).data

  const listConfigDocuments = async (): Promise<IConfigDocument[]> =>
    (await apiUrl.get('/configuration/documents')).data

  return {
    configurationList,
    updateConfiguration,
    uploadConfigDocument,
    publishConfigDocument,
    downloadConfigDocumentDraft,
    downloadConfigDocumentPublished,
    listConfigDocuments,
  }
}
